import { useEffect, useState } from "react";
import { useAdsSpyStore } from "../store/adsSpyStore";
import BookmarksGrid from "./BookmarksGrid";
import GrowthRadarView from "./GrowthRadarView";
import GrowthFavoritesView from "./GrowthFavoritesView";
import AdDetailModal from "./AdDetailModal";
import type { SpyAd } from "../types/adsSpy.types";
import { CreateAdWithIAModal } from "../../cretives/components/modals/CreateAdWithIAModal";

export type AdsSpyViewMode = "radar" | "favorites";

interface AdsSpyViewProps {
  onSwitchToImages?: () => void;
  /** When set, auto-opens the detail modal for this ad on first mount. */
  initialDetailAdId?: number | null;
  viewMode?: AdsSpyViewMode;
  searchOpenSignal?: number;
}

export default function AdsSpyView({
  onSwitchToImages,
  initialDetailAdId,
  viewMode = "radar",
  searchOpenSignal = 0,
}: AdsSpyViewProps) {
  const {
    setCurrentTab,
    loadBrands,
    loadAds,
    loadAiFilters,
    bookmarks,
    loadBookmarks,
  } = useAdsSpyStore();

  const [detailAdId, setDetailAdId] = useState<number | null>(initialDetailAdId ?? null);
  const [spyAdReference, setSpyAdReference] = useState<SpyAd | null>(null);
  const [showAdStudio, setShowAdStudio] = useState(false);

  useEffect(() => {
    if (initialDetailAdId) {
      setCurrentTab("ads");
      loadBrands();
      loadAiFilters();
      loadAds(true);
      loadBookmarks();
    }
  }, []);

  useEffect(() => {
    if (viewMode === "favorites") {
      loadBookmarks();
    }
  }, [viewMode, loadBookmarks]);

  return (
    <div>
      {viewMode === "radar" && (
        <GrowthRadarView
          searchOpenSignal={searchOpenSignal}
          onCreateSimilar={(ad) => {
            setSpyAdReference(ad);
            setShowAdStudio(true);
          }}
        />
      )}

      {viewMode === "favorites" && (
        <div className="space-y-8">
          <GrowthFavoritesView
            onCreateSimilar={(ad) => {
              setSpyAdReference(ad);
              setShowAdStudio(true);
            }}
          />
          {bookmarks.length > 0 && (
            <div className="border-t border-gray-200 pt-6">
              <h3 className="mb-4 text-sm font-semibold text-gray-900">Favoritos manuales</h3>
              <BookmarksGrid
                onClickDetail={(id) => setDetailAdId(id)}
              />
            </div>
          )}
        </div>
      )}

      {/* Modals */}
      <AdDetailModal
        open={detailAdId !== null}
        onClose={() => setDetailAdId(null)}
        adId={detailAdId}
      />

      <CreateAdWithIAModal
        open={showAdStudio}
        onClose={() => {
          setShowAdStudio(false);
          setSpyAdReference(null);
        }}
        onGenerated={onSwitchToImages}
        initialReference={
          spyAdReference
            ? {
                image_url: spyAdReference.thumbnail_url || spyAdReference.image_url || "",
                headline: spyAdReference.headline || undefined,
                ad_copy: spyAdReference.ad_copy || undefined,
              }
            : undefined
        }
      />

    </div>
  );
}
